import React from 'react'
import { UserSaleOffer } from 'src/core/models'
import styles from './SaleOfferActionsColumn.module.scss'
import SaleOfferAcceptButton from './SaleOfferAcceptButton/SaleOfferAcceptButton'
import SaleOfferDetailsButton from './SaleOfferDetailsButton/SaleOfferDetailsButton'

const SaleOfferActionsColumn: React.FC<{ offer: UserSaleOffer }> = ({ offer }) => {

  return <div className={styles.content}>
    {/* Details */}
    <SaleOfferDetailsButton offer={offer} />
    {/* Accept */}
    <SaleOfferAcceptButton offer={offer} />
  </div>
}

export default SaleOfferActionsColumn
